import script from "./MediaflowSourcesTip.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowSourcesTip.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowSourcesTip.vue?vue&type=style&index=0&id=78b5106b&lang=css"

const __exports__ = script;

export default __exports__